import axios from 'axios';
import BaseAPI from './base/base-api';

class IntructionVideoAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'intructionsvideo';
}

export default new IntructionVideoAPI();
